$(document).ready(function() {
  //wow
  new WOW().init();

  $(function() {
    var url = window.location.href;

    $(".menubar a").each(function() {
      // checks if its the same on the address bar
      if (url == (this.href)) {
        $(this).closest("a").addClass("active");
        //for making parent of submenu active
        $(this).closest("a").parent().parent().addClass("active");
      }
    });
  });

  //cookies
  if (localStorage.getItem('cookiesbar') !== 'true') {
    $('.cookiesbar').fadeIn();
  } else {
    $('.cookiesbar').fadeOut();
  };

  $('.closebtn').click(function() {
    localStorage.setItem('cookiesbar', 'true');
    $('.cookiesbar').fadeOut();
  });

  //sliding effect
  $('.tabLinks a, .servicesLink a').on('click', function(e) {
    var anchor = $(this);
    $('html, body').stop().animate({
      scrollTop: $(anchor.attr('href')).offset().top - 66
    }, 1000);
    e.preventDefault();
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $('.menubar').addClass('menu-shrink');
    } else {
      $('.menubar').removeClass('menu-shrink');
    }
  });

  /***Scroll bottton to top script***/
  var offset = 300,
    //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
    offset_opacity = 1200,
    //duration of the top scrolling animation (in ms)
    scroll_top_duration = 700,
    //grab the "back to top" link
    $back_to_top = $('.cd-top');

  //hide or show the "back to top" link
  $(window).scroll(function() {
    ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible'): $back_to_top.removeClass('cd-is-visible cd-fade-out');
    if ($(this).scrollTop() > offset_opacity) {
      $back_to_top.addClass('cd-fade-out');
    }
  });

  //smooth scroll to top
  $back_to_top.on('click', function(event) {
    event.preventDefault();
    $('body,html').animate({
      scrollTop: 0,
    }, scroll_top_duration);
  });

  // Video js //
  // $(".video").click(function () {
  //     console.log('video');
  //     var theModal = $(this).data("target"),
  //     videoSRC = $(this).attr("data-video"),
  //     videoSRCauto = videoSRC + "?modestbranding=1&rel=0&controls=0&showinfo=0&html5=1&autoplay=1";
  //     $(theModal + ' iframe').attr('src', videoSRCauto);
  //     $(theModal + ' button.close').click(function () {
  //         $('video').trigger('pause');
  //         $(theModal + ' iframe').attr('src', videoSRC);
  //     });
  // });

  jQuery(document).ready(function() {
    jQuery('[data-toggle="modal"]').each(function() {
      jQuery(this).attr('data-backdrop', 'static');
      jQuery(this).attr('data-keyboard', 'false');
    });
  });

  //revealOnScroll//
  $(function() {
    var $window = $(window),
      win_height_padded = $window.height() * 1.1,
      isTouch = Modernizr.touch;
    if (isTouch) {
      $('.revealOnScroll').addClass('animated');
    }

    $window.on('scroll', revealOnScroll);

    function revealOnScroll() {
      var scrolled = $window.scrollTop(),
        win_height_padded = $window.height() * 1.1;
      // Showed...
      $(".revealOnScroll:not(.animated)").each(function() {
        var $this = $(this),
          offsetTop = $this.offset().top;
        if (scrolled + win_height_padded > offsetTop) {
          if ($this.data('timeout')) {
            window.setTimeout(function() {
              $this.addClass('animated ' + $this.data('animation'));
            }, parseInt($this.data('timeout'), 10));
          } else {
            $this.addClass('animated ' + $this.data('animation'));
          }
        }
      });
      // Hidden...
      $(".revealOnScroll.animated").each(function(index) {
        var $this = $(this),
          offsetTop = $this.offset().top;
        if (scrolled + win_height_padded < offsetTop) {
          $(this).removeClass('animated fadeInUp flipInX lightSpeedIn slideInUp')
        }
      });
    }
    revealOnScroll();
  });

  /*$('.greyContainer .leftIcon').addClass('animated slideInUp');*/
  // $('#videoModal').on('shown.bs.modal', function (e) {
  //     // do something...
  //     var video = $(this).find('video').get(0);
  //         video.currentTime = 0;
  //         video.play();
  // });
  $('.videobtn').click(function() {
    $('video').each(function() {
      $(this).get(0).pause();
    })
  });
  $('.videobtn1').click(function() {
    $('#video1').each(function() {
      $(this).get(0).play();
    })
  });

  $('.videobtn2').click(function() {
    $('#video2').each(function() {
      $(this).get(0).play();
    })
  });

  // $('#videoModal').on('hidden.bs.modal', function (e) {
  //     // do something...
  //     console.log('ssss');
  //     $(this).find('video')[0].pause();
  //     $(this).find('video')[0].currentTime = 0;
  // });

  // $('#videoModal2').on('shown.bs.modal', function (e) {
  //     // do something...
  //     var video = $(this).find('video').get(0);
  //         video.currentTime = 0;
  //         video.play();
  // });

  // $('#videoModal2').on('hidden.bs.modal', function (e) {
  //     // do something...
  //     $(this).find('video')[0].pause();
  //     $(this).find('video')[0].currentTime = 0;
  // });
  $('.close').click(function() {
    $('video').each(function() {
      $(this).get(0).pause();
    })
  });


})
